import React, { memo } from "react";
import PT from "prop-types";
import Info from "_c/atoms/Info";
import { ClientsAPI } from "@/api/clients";
import Row from "./Row";
import messengers from "@/misc/messengers-sub-list";
import { SITE_URL } from "@/misc/constants";
import { useQuery, useQueryClient } from "react-query";
import { QueryKeys } from "@/network/queryKeys";
import QueryRequest from "_c/QueryRequest";

const ns = "common:client_ext_msgr_sub";
const ClientMessengerSub = ({
  clientId,
  isClientRealUser,
  shouldUseSiteProxy,
  t,
}) => {
  const queryClient = useQueryClient();
  const queryKey = [
    QueryKeys.clientMessengerSub,
    {
      clientId,
    },
  ];
  const query = useQuery(
    queryKey,
    () => ClientsAPI.getExtMessengerSub(clientId).then(({ data }) => data),
    {
      enabled: Boolean(clientId && !isClientRealUser),
    }
  );
  if (isClientRealUser) {
    return <Info isError>{t(`${ns}.real_client_sub_disabled`)}</Info>;
  }
  const updateData = (data) => {
    queryClient.setQueryData(queryKey, data);
  };
  return (
    <QueryRequest query={query}>
      <>
        {messengers.map(({ linkGenerator, key, icon }) => (
          <Row
            ns={ns}
            token={query.data?._id}
            link={
              shouldUseSiteProxy
                ? `${SITE_URL}/messenger/sub/${query.data?._id}`
                : linkGenerator(query.data?._id)
            }
            key={key}
            updateData={updateData}
            messenger={key}
            isActive={query.data?.[key]?.active}
            icon={icon}
            t={t}
          />
        ))}
        <Info cta>{t(`${ns}.advice`)}</Info>
      </>
    </QueryRequest>
  );
};
ClientMessengerSub.propTypes = {
  clientId: PT.string,
  isClientRealUser: PT.bool,
  shouldUseSiteProxy: PT.bool,

  t: PT.func.isRequired,
};
export default memo(ClientMessengerSub);
